/**
 * ENFAMI Product Configurator
 * - Customize toggle (FREE)
 * - Patch checkboxes
 * - Size finder + size guide modals
 * - Line item properties on /cart/add
 */
(function () {
  'use strict';

  var FLOCAGE_OPTION = 'Flocage';
  var VAL_NONE = ['non', 'aucun', 'sans flocage', 'no', "don't", 'dont'];
  var VAL_SIMPLE = ['flocage simple', 'flocage ldc', 'simple', 'ldc'];
  var VAL_PHOTO = ['flocage photo', 'photo'];

  function norm(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function getCustomizeMode(root) {
    var checked = root.querySelector('[data-efc-customize]:checked');
    return checked ? checked.value : 'none';
  }

  function getSelectedPatches(root) {
    return Array.prototype.slice
      .call(root.querySelectorAll('[data-efc-patch-cb]:checked'))
      .map(function (el) { return el.value; })
      .filter(Boolean);
  }

  function getPropsFromRoot(root) {
    var props = {};
    if (window.EnfamiPatches && typeof window.EnfamiPatches.getProps === 'function') {
      props = Object.assign(props, window.EnfamiPatches.getProps() || {});
    } else {
      var patches = getSelectedPatches(root);
      if (patches.length) props['Patches'] = patches.join(' | ');
    }

    if (getCustomizeMode(root) === 'none') return props;

    var panel = root.querySelector('[data-efc-flocage-panel]');
    if (!panel || panel.hidden) return props;

    var nom = root.querySelector('[data-efc-nom]');
    var num = root.querySelector('[data-efc-num]');
    var bas = root.querySelector('[data-efc-bas]');
    if (nom && nom.value.trim()) props['Nom du Haut'] = nom.value.trim();
    if (num && num.value.trim()) props['Numéro'] = num.value.trim();
    if (bas && bas.value.trim()) props['Nom du bas'] = bas.value.trim();

    var files = root._efcFiles || [];
    if (files.length) {
      props['Flocage'] = 'Flocage photo (+15 $)';
      props['Nombre photos'] = String(files.length);
      if (!usePhotoCompanionBilling()) {
        props['Supplément photo'] = '15.00 $';
      }
    } else {
      props['Flocage'] = 'Flocage simple (offert)';
    }

    props['Personnalisation'] = 'Oui';
    return props;
  }

  function getProductAddForm() {
    return (
      document.querySelector('product-form-component form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  /** Place les fichiers dans le formulaire produit (FormData natif Shopify). */
  function syncPhotosToProductForm(root) {
    var form = getProductAddForm();
    if (!form) return;
    form.querySelectorAll('[data-efc-synced-file]').forEach(function (el) {
      el.remove();
    });
    var files = root._efcFiles || [];
    if (!files.length || typeof DataTransfer === 'undefined') return;

    files.forEach(function (file, i) {
      var input = document.createElement('input');
      input.type = 'file';
      input.name =
        files.length === 1
          ? 'properties[Photo flocage]'
          : 'properties[Photo flocage ' + (i + 1) + ']';
      input.setAttribute('data-efc-synced-file', '1');
      input.hidden = true;
      input.style.display = 'none';
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        form.appendChild(input);
      } catch (e) { /* navigateur sans DataTransfer */ }
    });
  }

  function stripContentType(init) {
    if (!init || !init.headers) return init;
    var nextHeaders = {};
    var src = init.headers;
    if (src instanceof Headers) {
      src.forEach(function (val, key) {
        if (String(key).toLowerCase() !== 'content-type') nextHeaders[key] = val;
      });
    } else if (Array.isArray(src)) {
      src.forEach(function (pair) {
        if (String(pair[0]).toLowerCase() !== 'content-type') nextHeaders[pair[0]] = pair[1];
      });
    } else {
      Object.keys(src).forEach(function (key) {
        if (key.toLowerCase() !== 'content-type') nextHeaders[key] = src[key];
      });
    }
    return Object.assign({}, init, { headers: nextHeaders });
  }

  /** Attache les vrais fichiers au /cart/add (CDN Shopify → commande admin). */
  function attachPhotoFiles(init, root) {
    var files = root._efcFiles || [];
    if (!files.length || !init) return init;

    syncPhotosToProductForm(root);

    var fd = null;
    var useItemsPrefix = false;

    if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
      fd = init.body;
      useItemsPrefix = !!fd.get('items[0][id]');
    } else if (typeof init.body === 'string') {
      try {
        var data = JSON.parse(init.body);
        fd = new FormData();
        if (data.items && data.items[0]) {
          useItemsPrefix = true;
          data.items.forEach(function (item, idx) {
            fd.set('items[' + idx + '][id]', String(item.id));
            fd.set('items[' + idx + '][quantity]', String(item.quantity || 1));
            var p = item.properties || {};
            Object.keys(p).forEach(function (k) {
              fd.set('items[' + idx + '][properties][' + k + ']', p[k]);
            });
          });
          if (data.sections) fd.set('sections', data.sections);
        } else if (data.id) {
          fd.set('id', String(data.id));
          fd.set('quantity', String(data.quantity || 1));
          var props = data.properties || {};
          Object.keys(props).forEach(function (k) {
            fd.set('properties[' + k + ']', props[k]);
          });
          if (data.sections) fd.set('sections', data.sections);
        }
      } catch (e) {
        return init;
      }
    }

    if (!fd) return init;

    files.forEach(function (file, i) {
      var label =
        files.length === 1 ? 'Photo flocage' : 'Photo flocage ' + (i + 1);
      var key = useItemsPrefix
        ? 'items[0][properties][' + label + ']'
        : 'properties[' + label + ']';
      fd.set(key, file, file.name);
    });

    return stripContentType(Object.assign({}, init, { body: fd }));
  }

  function getProductData() {
    var el = document.getElementById('ep-product-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptionValues() {
    var map = {};
    document.querySelectorAll('variant-picker fieldset').forEach(function (fs) {
      var leg = fs.querySelector('legend');
      if (!leg) return;
      var name = (leg.textContent || '').replace(/\s+/g, ' ').trim();
      var checked = fs.querySelector('input[type="radio"]:checked, select');
      if (!checked) return;
      var val = checked.tagName === 'SELECT' ? checked.value : checked.value;
      if (val) map[name] = val;
    });
    return map;
  }

  function findOptionName(options, needleParts) {
    var list = options || [];
    for (var i = 0; i < list.length; i++) {
      var n = norm(list[i]);
      if (needleParts.some(function (p) { return n.indexOf(p) !== -1; })) return list[i];
    }
    return null;
  }

  function resolveVariantId(flocageDesired) {
    var data = getProductData();
    if (!data || !data.variants || !data.variants.length) return null;
    var options = data.options || [];
    var selected = getSelectedOptionValues();
    var flocageOpt = findOptionName(options, ['flocage', 'printing', 'customization']);
    var desiredValue = flocageDesired === 'photo' ? 'Flocage photo' : 'Flocage simple';

    if (flocageOpt) {
      /* Prefer exact / fuzzy match against available option values on variants */
      var candidates = {};
      data.variants.forEach(function (v) {
        var idx = options.indexOf(flocageOpt);
        if (idx < 0 || !v.options) return;
        var raw = v.options[idx];
        if (!raw) return;
        candidates[raw] = true;
      });
      var keys = Object.keys(candidates);
      var matched = null;
      keys.forEach(function (k) {
        var m = flocageMode(k);
        if (flocageDesired === 'photo' && m === 'photo') matched = k;
        if (flocageDesired !== 'photo' && m === 'simple') matched = matched || k;
      });
      if (matched) selected[flocageOpt] = matched;
      else selected[flocageOpt] = desiredValue;
    }

    var found = null;
    data.variants.forEach(function (v) {
      if (found || !v.options) return;
      var ok = true;
      for (var i = 0; i < options.length; i++) {
        var optName = options[i];
        var want = selected[optName];
        if (!want) continue;
        if (norm(v.options[i]) !== norm(want)) {
          /* fuzzy for flocage only */
          if (flocageOpt && optName === flocageOpt) {
            if (flocageMode(v.options[i]) !== flocageDesired && !(flocageDesired === 'simple' && flocageMode(v.options[i]) === 'simple')) {
              ok = false;
              break;
            }
          } else {
            ok = false;
            break;
          }
        }
      }
      if (ok) found = v;
    });

    if (!found && flocageOpt) {
      /* Fallback: keep non-flocage selections, match flocage mode only */
      data.variants.forEach(function (v) {
        if (found || !v.options) return;
        var idx = options.indexOf(flocageOpt);
        if (idx < 0) return;
        if (flocageMode(v.options[idx]) !== (flocageDesired === 'photo' ? 'photo' : 'simple')) return;
        var ok = true;
        for (var i = 0; i < options.length; i++) {
          if (i === idx) continue;
          var optName = options[i];
          var want = selected[optName];
          if (want && norm(v.options[i]) !== norm(want)) {
            ok = false;
            break;
          }
        }
        if (ok) found = v;
      });
    }

    return found ? found.id : null;
  }

  function setCartBodyVariantId(init, variantId) {
    if (!init || !variantId) return init;
    var idStr = String(variantId);

    try {
      if (typeof init.body === 'string') {
        var data = JSON.parse(init.body);
        if (data.items && Array.isArray(data.items) && data.items.length) {
          data.items[0].id = Number(idStr) || idStr;
        } else {
          data.id = Number(idStr) || idStr;
        }
        return Object.assign({}, init, { body: JSON.stringify(data) });
      }
      if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
        var fd = init.body;
        if (fd.get('items[0][id]')) fd.set('items[0][id]', idStr);
        else if (fd.get('id')) fd.set('id', idStr);
        else fd.set('id', idStr);
        return Object.assign({}, init, { body: fd });
      }
    } catch (e) { /* noop */ }

    document.querySelectorAll('form[action*="/cart/add"] [name="id"], product-form-component [name="id"]').forEach(function (el) {
      el.value = idStr;
    });
    return init;
  }

  function usePhotoCompanionBilling() {
    return !!(window.EnfamiPatches && typeof window.EnfamiPatches.photoAvailable === 'function' && window.EnfamiPatches.photoAvailable());
  }

  function appendCompanionPatches(init) {
    if (!init) return init;
    var extras = [];
    if (window.EnfamiPatches && typeof window.EnfamiPatches.companionItems === 'function') {
      extras = extras.concat(window.EnfamiPatches.companionItems() || []);
    }
    document.querySelectorAll('[data-enfami-configurator]').forEach(function (root) {
      if ((root._efcFiles || []).length && window.EnfamiPatches && typeof window.EnfamiPatches.photoCompanionItem === 'function') {
        var photoItem = window.EnfamiPatches.photoCompanionItem();
        if (photoItem) extras.push(photoItem);
      }
    });
    if (!extras.length || !init.body) return init;

    try {
      if (typeof init.body === 'string') {
        var data = JSON.parse(init.body);
        if (data.items && Array.isArray(data.items)) {
          data.items = data.items.concat(extras);
          return Object.assign({}, init, { body: JSON.stringify(data) });
        }
        if (data.id) {
          var merged = {
            items: [{ id: data.id, quantity: data.quantity || 1, properties: data.properties || {} }].concat(extras)
          };
          return Object.assign({}, init, { body: JSON.stringify(merged) });
        }
      }

      if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
        var fd = new FormData();
        init.body.forEach(function (val, key) { fd.append(key, val); });
        var vid = fd.get('id') || fd.get('items[0][id]');
        var qty = fd.get('quantity') || fd.get('items[0][quantity]') || '1';
        if (vid && !fd.get('items[0][id]')) {
          var propsFromFd = {};
          fd.forEach(function (val, key) {
            var m = key.match(/^properties\[(.+)\]$/);
            if (m) propsFromFd[m[1]] = val;
          });
          var next = new FormData();
          next.set('items[0][id]', String(vid));
          next.set('items[0][quantity]', String(qty));
          Object.keys(propsFromFd).forEach(function (k) {
            next.set('items[0][properties][' + k + ']', propsFromFd[k]);
          });
          extras.forEach(function (ex, i) {
            var idx = i + 1;
            next.set('items[' + idx + '][id]', String(ex.id));
            next.set('items[' + idx + '][quantity]', String(ex.quantity || 1));
            var exProps = ex.properties || {};
            Object.keys(exProps).forEach(function (k) {
              next.set('items[' + idx + '][properties][' + k + ']', exProps[k]);
            });
          });
          return Object.assign({}, init, { body: next });
        }
        if (fd.get('items[0][id]')) {
          var baseIdx = 0;
          while (fd.get('items[' + baseIdx + '][id]')) baseIdx += 1;
          extras.forEach(function (ex, i) {
            var idx = baseIdx + i;
            fd.set('items[' + idx + '][id]', String(ex.id));
            fd.set('items[' + idx + '][quantity]', String(ex.quantity || 1));
            var exProps2 = ex.properties || {};
            Object.keys(exProps2).forEach(function (k) {
              fd.set('items[' + idx + '][properties][' + k + ']', exProps2[k]);
            });
          });
          return Object.assign({}, init, { body: fd });
        }
      }
    } catch (e) { /* noop */ }
    return init;
  }

  function injectProps(init, props) {
    if (!init || !init.body || !Object.keys(props).length) return init;
    var body = init.body;

    if (typeof body === 'string') {
      try {
        var data = JSON.parse(body);
        if (data.items && Array.isArray(data.items) && data.items.length) {
          data.items[0].properties = Object.assign({}, data.items[0].properties || {}, props);
        } else {
          data.properties = Object.assign({}, data.properties || {}, props);
        }
        return Object.assign({}, init, { body: JSON.stringify(data) });
      } catch (e) { /* noop */ }
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var fd = new FormData();
      body.forEach(function (val, key) { fd.append(key, val); });
      Object.keys(props).forEach(function (k) {
        if (fd.get('items[0][id]')) {
          fd.set('items[0][properties][' + k + ']', props[k]);
        } else {
          fd.set('properties[' + k + ']', props[k]);
        }
      });
      return Object.assign({}, init, { body: fd });
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var sp = new URLSearchParams(body.toString());
      Object.keys(props).forEach(function (k) {
        sp.set('properties[' + k + ']', props[k]);
      });
      return Object.assign({}, init, { body: sp });
    }

    return init;
  }

  function readFlocageFromPage() {
    var selected = null;
    document.querySelectorAll('input[type="radio"]:checked, select option:checked').forEach(function (el) {
      var label = el.value || el.textContent || '';
      if (norm(label).indexOf('flocage') !== -1 || (el.name && el.name.toLowerCase().indexOf('flocage') !== -1)) {
        selected = label;
      }
    });
    document.querySelectorAll('fieldset').forEach(function (fs) {
      var leg = fs.querySelector('legend');
      if (!leg || norm(leg.textContent) !== 'flocage') return;
      var checked = fs.querySelector('input:checked');
      if (checked) selected = checked.value;
    });
    return selected;
  }

  function flocageMode(value) {
    var v = norm(value);
    if (!v || VAL_NONE.some(function (x) { return v.indexOf(x) !== -1; })) return 'none';
    if (VAL_PHOTO.some(function (x) { return v.indexOf(x) !== -1; })) return 'photo';
    if (VAL_SIMPLE.some(function (x) { return v.indexOf(x) !== -1; }) || v.indexOf('flocage') !== -1) return 'simple';
    return 'none';
  }

  function updatePanel(root) {
    var panel = root.querySelector('[data-efc-flocage-panel]');
    var upload = root.querySelector('[data-efc-upload-zone]');
    if (!panel) return;

    /* Champs + photo optionnelle uniquement si "Personnaliser" */
    var customize = getCustomizeMode(root);
    if (customize === 'yes') {
      panel.hidden = false;
      if (upload) upload.hidden = false;
    } else {
      panel.hidden = true;
      if (upload) upload.hidden = true;
      clearPhotos(root);
    }
    syncFlocageVariant(root);
  }

  function clearPhotos(root) {
    var preview = root.querySelector('[data-efc-preview]');
    if (preview) {
      preview.querySelectorAll('img[src^="blob:"]').forEach(function (img) {
        try { URL.revokeObjectURL(img.src); } catch (e) { /* noop */ }
      });
      preview.innerHTML = '';
    }
    root._efcFiles = [];
    var input = root.querySelector('[data-efc-file-input]');
    if (input) input.value = '';
    var countEl = root.querySelector('[data-efc-count]');
    var max = parseInt(root.getAttribute('data-max-photos') || '10', 10);
    if (countEl) countEl.textContent = '0 / ' + max;
    var surcharge = root.querySelector('[data-efc-photo-surcharge]');
    if (surcharge) surcharge.hidden = true;
    syncPhotosToProductForm(root);
  }

  function syncFileInputFromState(root) {
    var input = root.querySelector('[data-efc-file-input]');
    if (!input || typeof DataTransfer === 'undefined') return;
    try {
      var dt = new DataTransfer();
      (root._efcFiles || []).forEach(function (file) {
        dt.items.add(file);
      });
      input.files = dt.files;
    } catch (e) {
      /* certains navigateurs refusent de réécrire input.files */
    }
  }

  function renderPhotoPreviews(root) {
    var preview = root.querySelector('[data-efc-preview]');
    var countEl = root.querySelector('[data-efc-count]');
    var max = parseInt(root.getAttribute('data-max-photos') || '10', 10);
    var files = root._efcFiles || [];
    if (!preview) return;

    preview.querySelectorAll('img[src^="blob:"]').forEach(function (img) {
      try { URL.revokeObjectURL(img.src); } catch (e) { /* noop */ }
    });
    preview.innerHTML = '';

    files.forEach(function (file, index) {
      var item = document.createElement('div');
      item.className = 'efc__upload-thumb';
      item.setAttribute('data-efc-thumb-index', String(index));

      var img = document.createElement('img');
      img.alt = file.name || ('Photo ' + (index + 1));
      img.src = URL.createObjectURL(file);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'efc__upload-remove';
      remove.setAttribute('data-efc-remove-photo', String(index));
      remove.setAttribute('aria-label', 'Supprimer la photo ' + (index + 1));
      remove.innerHTML =
        '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
        '<path d="M2.1 2.1l7.8 7.8M9.9 2.1L2.1 9.9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg>';

      item.appendChild(img);
      item.appendChild(remove);
      preview.appendChild(item);
    });

    if (countEl) countEl.textContent = files.length + ' / ' + max;
  }

  function removePhotoAt(root, index) {
    var files = root._efcFiles || [];
    if (index < 0 || index >= files.length) return;
    files.splice(index, 1);
    root._efcFiles = files;
    syncFileInputFromState(root);
    renderPhotoPreviews(root);
    syncPhotosToProductForm(root);
    syncFlocageVariant(root);
  }

  function bindUpload(root) {
    var input = root.querySelector('[data-efc-file-input]');
    var preview = root.querySelector('[data-efc-preview]');
    var max = parseInt(root.getAttribute('data-max-photos') || '10', 10);
    if (!input) return;

    root._efcFiles = root._efcFiles || [];

    input.addEventListener('change', function () {
      var incoming = Array.from(input.files || []);
      if (!incoming.length) return;

      var next = (root._efcFiles || []).slice();
      var room = max - next.length;
      if (room <= 0) {
        alert('Maximum ' + max + ' photos.');
        input.value = '';
        return;
      }
      if (incoming.length > room) {
        alert('Maximum ' + max + ' photos.');
      }
      incoming.slice(0, room).forEach(function (file) {
        var duplicate = next.some(function (f) {
          return f.name === file.name && f.size === file.size && f.lastModified === file.lastModified;
        });
        if (!duplicate) next.push(file);
      });

      root._efcFiles = next;
      syncFileInputFromState(root);
      renderPhotoPreviews(root);
      syncPhotosToProductForm(root);
      syncFlocageVariant(root);
      /* reset pour permettre de re-sélectionner le même fichier après suppression */
      input.value = '';
    });

    if (preview && !preview.getAttribute('data-efc-remove-bound')) {
      preview.setAttribute('data-efc-remove-bound', '1');
      preview.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-efc-remove-photo]');
        if (!btn || !preview.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(btn.getAttribute('data-efc-remove-photo') || '-1', 10);
        removePhotoAt(root, idx);
      });
    }
  }

  function desiredFlocageMode(root) {
    if (getCustomizeMode(root) !== 'yes') return 'simple';
    var files = root._efcFiles || [];
    return files.length > 0 ? 'photo' : 'simple';
  }

  function findFlocageInputs() {
    var list = [];
    document.querySelectorAll('variant-picker fieldset, fieldset.ep-variant--flocage, fieldset').forEach(function (fs) {
      var leg = fs.querySelector('legend');
      if (!leg) return;
      var name = norm(leg.textContent).replace(/\s+/g, ' ');
      if (name.indexOf('flocage') === -1 && name.indexOf('printing') === -1 && name.indexOf('customization') === -1) {
        return;
      }
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        list.push(input);
      });
    });
    return list;
  }

  function syncFlocageVariant(root) {
    var mode = desiredFlocageMode(root);
    /* Avec produit compagnon photo : on garde la variante SIMPLE sur le maillot
       et on facture +15 via la ligne compagnon (évite double facturation / race Horizon). */
    var billingMode = mode;
    if (mode === 'photo' && usePhotoCompanionBilling()) {
      billingMode = 'simple';
    }

    var inputs = findFlocageInputs();
    if (inputs.length) {
      var target = null;
      var fallbackSimple = null;
      inputs.forEach(function (input) {
        var m = flocageMode(input.value);
        if (billingMode === 'photo' && m === 'photo') target = input;
        if (m === 'simple') fallbackSimple = input;
        if (billingMode !== 'photo' && m === 'simple') target = input;
        if (billingMode !== 'photo' && m === 'none' && !target) target = input;
      });
      if (!target) target = fallbackSimple || inputs[0];
      if (target && !target.checked) {
        target.checked = true;
        try {
          target.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) { /* noop */ }
      }
    }

    var resolvedId = resolveVariantId(billingMode);
    if (resolvedId) {
      document.querySelectorAll('form[action*="/cart/add"] [name="id"], product-form-component [name="id"]').forEach(function (el) {
        el.value = String(resolvedId);
      });
    }

    updatePhotoSurchargeUI(root, mode === 'photo');
    return resolvedId;
  }

  function updatePhotoSurchargeUI(root, active) {
    var el = root.querySelector('[data-efc-photo-surcharge]');
    var moneyLabel =
      (window.EnfamiPatches && typeof window.EnfamiPatches.photoPriceMoney === 'function' && window.EnfamiPatches.photoPriceMoney()) ||
      '+15 $';
    if (el) {
      el.hidden = !active;
      el.textContent = moneyLabel + ' flocage photo ajoutés au prix';
    }

    var note = document.querySelector('[data-efc-photo-price-note]');
    if (!note) {
      var host =
        document.querySelector('product-price, [ref="priceContainer"], .price') ||
        document.querySelector('.product-information');
      if (host) {
        note = document.createElement('p');
        note.setAttribute('data-efc-photo-price-note', '');
        note.className = 'efc__price-note efc__price-note--photo';
        host.appendChild(note);
      }
    }
    if (note) {
      if (active) {
        note.hidden = false;
        note.textContent = 'Dont ' + moneyLabel + ' de flocage photo';
      } else {
        note.hidden = true;
      }
    }
  }

  function recommendSize(height, weight, fit) {
    var score = height + weight * 0.35;
    if (fit === 'slim') score -= 4;
    if (fit === 'loose') score += 4;
    if (score < 210) return 'S';
    if (score < 225) return 'M';
    if (score < 240) return 'L';
    if (score < 255) return 'XL';
    if (score < 270) return '2XL';
    if (score < 285) return '3XL';
    return '4XL';
  }

  var KIDS_SIZE_LABELS = {
    '16': '02-03 ans',
    '18': '03-04 ans',
    '20': '04-05 ans',
    '22': '06-07 ans',
    '24': '08-09 ans',
    '26': '10-11 ans',
    '28': '12-13 ans'
  };

  (function syncKidsLabelsLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('fr') === 0) return;
    KIDS_SIZE_LABELS = {
      '16': '02-03 Years',
      '18': '03-04 Years',
      '20': '04-05 Years',
      '22': '06-07 Years',
      '24': '08-09 Years',
      '26': '10-11 Years',
      '28': '12-13 Years'
    };
  })();

  function isKidsProduct() {
    if (document.querySelector('variant-picker[data-kids-product="true"], [data-enfami-configurator][data-kids-product="true"]')) {
      return true;
    }
    try {
      var dataEl = document.getElementById('ep-product-data');
      if (dataEl) {
        var data = JSON.parse(dataEl.textContent || '{}');
        if (data && data.isKids) return true;
      }
    } catch (e) {}
    return false;
  }

  function recommendKidsSize(height) {
    if (height < 105) return '16';
    if (height < 115) return '18';
    if (height < 125) return '20';
    if (height < 135) return '22';
    if (height < 145) return '24';
    if (height < 155) return '26';
    return '28';
  }

  function selectVariantSize(size) {
    var target = String(size || '').trim();
    if (!target) return;
    var kids = isKidsProduct();
    document.querySelectorAll('.ep-variant--size .variant-option__button-label, .ep-variant--size label').forEach(function (el) {
      var input = el.querySelector('input');
      if (!input) return;
      var val = String(input.value || '').trim();
      var txt = (el.textContent || '').trim().toUpperCase().replace(/\s+/g, '');
      var match = false;
      if (kids) {
        match = val === target || txt.indexOf(target) !== -1 ||
          (KIDS_SIZE_LABELS[target] && txt === KIDS_SIZE_LABELS[target].toUpperCase().replace(/\s+/g, ''));
      } else {
        match = txt === target.toUpperCase().replace(/\s+/g, '') ||
          txt === target.toUpperCase().replace(/\s+/g, '').replace('2XL', 'XXL') ||
          val.toUpperCase() === target.toUpperCase();
      }
      if (match) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        el.click();
      }
    });
  }

  function getFinder() {
    return document.querySelector('.efc-modal[data-efc-finder], [data-efc-finder].efc-modal');
  }

  function getGuide() {
    return document.querySelector('.efc-modal[data-efc-guide], [data-efc-guide].efc-modal');
  }

  function mountModalsToBody() {
    [getFinder(), getGuide()].forEach(function (el) {
      if (el && el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  function openModal(el) {
    if (!el) return;
    mountModalsToBody();
    el.hidden = false;
    el.removeAttribute('hidden');
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('efc-modal-open');
    document.body.style.overflow = 'hidden';
    /* Ignore les closes parasites du même geste (click sur backdrop) */
    el.dataset.efcJustOpened = '1';
    setTimeout(function () {
      delete el.dataset.efcJustOpened;
    }, 320);
  }

  function closeModal(el) {
    if (!el) return;
    if (el.dataset.efcJustOpened === '1') return;
    el.hidden = true;
    el.setAttribute('hidden', '');
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    var finder = getFinder();
    var guide = getGuide();
    var anyOpen =
      (finder && finder.classList.contains('is-open')) ||
      (guide && guide.classList.contains('is-open'));
    if (!anyOpen) {
      document.documentElement.classList.remove('efc-modal-open');
      document.body.style.overflow = '';
    }
  }

  function bindModals() {
    if (document.documentElement.dataset.efcModalDelegation === 'true') return;
    document.documentElement.dataset.efcModalDelegation = 'true';

    mountModalsToBody();

    window.EnfamiSizeModals = {
      openFinder: function () { openModal(getFinder()); },
      openGuide: function () { openModal(getGuide()); },
      closeFinder: function () { closeModal(getFinder()); },
      closeGuide: function () { closeModal(getGuide()); }
    };

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (t && t.nodeType === 3) t = t.parentElement;
        if (!t || !t.closest) return;

        if (t.closest('[data-efc-open-finder]')) {
          e.preventDefault();
          e.stopPropagation();
          openModal(getFinder());
          return;
        }
        if (t.closest('[data-efc-open-guide]')) {
          e.preventDefault();
          e.stopPropagation();
          openModal(getGuide());
          return;
        }
        if (t.closest('[data-efc-close-finder]')) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(getFinder());
          return;
        }
        if (t.closest('[data-efc-close-guide]')) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(getGuide());
        }
      },
      true
    );

    /* Empêche le <legend> de voler le focus sans ouvrir (sinon click → backdrop → fermeture) */
    document.addEventListener(
      'mousedown',
      function (e) {
        var t = e.target;
        if (t && t.nodeType === 3) t = t.parentElement;
        if (!t || !t.closest) return;
        if (t.closest('[data-efc-open-finder]') || t.closest('[data-efc-open-guide]')) {
          e.preventDefault();
        }
      },
      true
    );

    var calc = document.querySelector('[data-efc-calc-size]');
    var result = document.querySelector('[data-efc-finder-result]');
    if (calc && result && !calc.dataset.efcCalcBound) {
      calc.dataset.efcCalcBound = '1';
      calc.addEventListener('click', function () {
        var kids = isKidsProduct();
        var h = parseFloat((document.querySelector('[data-efc-finder-h]') || {}).value);
        if (kids) {
          if (!h) {
            result.hidden = false;
            result.textContent = '—';
            return;
          }
          var kidsSize = recommendKidsSize(h);
          var kidsLabel = KIDS_SIZE_LABELS[kidsSize] || kidsSize;
          result.hidden = false;
          result.textContent = kidsLabel + ' (size ' + kidsSize + ')';
          selectVariantSize(kidsSize);
          return;
        }
        var w = parseFloat((document.querySelector('[data-efc-finder-w]') || {}).value);
        var fitEl = document.querySelector('[data-efc-finder-fit]:checked');
        var fit = fitEl ? fitEl.value : 'regular';
        if (!h || !w) {
          result.hidden = false;
          result.textContent = '—';
          return;
        }
        var size = recommendSize(h, w, fit);
        result.hidden = false;
        result.textContent = size;
        selectVariantSize(size);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal(getFinder());
        closeModal(getGuide());
      }
    });
  }

  function bindSizePriceNote() {
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.title) return;
      var t = variant.title.toUpperCase();
      var note = document.querySelector('[data-efc-size-note]');
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-efc-size-note', '');
        note.style.cssText = 'font-size:12px;color:#666;margin:8px 0 0;';
        var price = document.querySelector('product-price, [ref="priceContainer"], .price');
        if (price && price.parentNode) price.parentNode.appendChild(note);
      }
      if (t.indexOf('3XL') !== -1 || t.indexOf('4XL') !== -1 || t.indexOf('XXXL') !== -1) {
        note.textContent = '3XL / 4XL';
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    });
  }

  function initRoot(root) {
    if (root._efcInit) return;
    root._efcInit = true;
    bindUpload(root);
    bindModals();
    updatePanel(root);

    root.addEventListener('change', function () { updatePanel(root); });
    document.addEventListener('click', function () {
      setTimeout(function () { updatePanel(root); }, 80);
    });
  }

  function initAll() {
    bindModals();
    document.querySelectorAll('[data-enfami-configurator]').forEach(initRoot);
  }

  var _fetch = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    if (url.indexOf('/cart/add') !== -1) {
      document.querySelectorAll('[data-enfami-configurator]').forEach(function (root) {
        var resolvedId = syncFlocageVariant(root);
        syncPhotosToProductForm(root);
        var props = getPropsFromRoot(root);
        if (Object.keys(props).length) {
          init = injectProps(init || {}, props);
        }
        init = attachPhotoFiles(init || {}, root);
        if (resolvedId) {
          init = setCartBodyVariantId(init || {}, resolvedId);
        }
      });
      init = appendCompanionPatches(init || {});
    }
    return _fetch.call(this, resource, init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  bindSizePriceNote();
  document.addEventListener('shopify:section:load', initAll);
})();
